import { useMemo } from "react"

import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadwayStateContext } from "../../../contexts/RoadwayContext"

import { useNetworkConditionForYearlyStatus } from "../networkConditions/useNetworkConditionForYearlyStatus"

import { useDamages } from "./useDamages"

export function useDamagesStatsOnSegments(road, absStart = null, absEnd = null) {
    const { selectedNetworkYearlyStatus } = useRoadwayStateContext()

    const {
        networkCondition,
        isLoading: isLoadingNetworkCondition,
        isError: isErrorNetworkCondition,
    } = useNetworkConditionForYearlyStatus(selectedNetworkYearlyStatus)

    const queryParams = useExtendWithSubnetworks({
        layer: networkCondition?.layer,
        linear_location_road: road,
        ...(absStart && { linear_location_start: absStart }),
        ...(absEnd && { linear_location_end: absEnd }),
        year: networkCondition?.year,
    }, API_MODULE_ROADWAY)

    const {
        data: selectedNetworkDamages,
        isLoading: isLoadingDamages,
        isError: isErrorDamages,
    } = useDamages(
        networkCondition,
        queryParams,
        { enabled: !!(road && !!networkCondition?.survey) },
    )
    const isLoading = isLoadingNetworkCondition || (isLoadingDamages && !!networkCondition?.layer)
    const isError = isErrorNetworkCondition || isErrorDamages

    const selectedNetworkDamagesStats = useMemo(() => {
        const selectedNetworkDamagesFeatures = selectedNetworkDamages?.features
        if (!selectedNetworkDamagesFeatures?.length || isLoading || isError) {
            return null
        }

        const damagesLinearLocations = selectedNetworkDamagesFeatures.map((damageFeature) => {
            return {
                damageType: damageFeature.properties.damageType,
                start: damageFeature.linearLocation.start,
                end: damageFeature.linearLocation.end,
            }
        })

        const uniqueDamagesStats = {}

        damagesLinearLocations.forEach((damageLinearLocation) => {
            const damageStat = Math.abs(damageLinearLocation.end - damageLinearLocation.start)
            if (damageLinearLocation.damageType in uniqueDamagesStats) {
                uniqueDamagesStats[damageLinearLocation.damageType].damageStat += damageStat
            } else {
                uniqueDamagesStats[damageLinearLocation.damageType] = { damageCode: damageLinearLocation.damageType, damageStat }
            }
        })

        return Object.values(uniqueDamagesStats)
    }, [
        selectedNetworkDamages,
        isLoading,
        isError])

    return { data: selectedNetworkDamagesStats, isLoading, isError }
}